<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px; z-index: 1;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
<div class="col-12">
  <div class="col-6" class="container" >
      <div class="row">
      <div class="col">
          <div class="col-4 border border-info rounded">
            <div class="col-12 flex p-0">
              <div class="col-6 p-0">
                <p-radioButton name="redoGroup" value='PlateView' label="Search for a Plate" [(ngModel)]="typeOfView" (click)="resetData()" (keypress)="resetData()"></p-radioButton>
              </div>
              <div class="col-6 p-0">
                <p-radioButton name="redoGroup" value='SampleView' label="Search for a Sample" [(ngModel)]="typeOfView" (click)="resetData()" (keypress)="resetData()"></p-radioButton>
              </div>
            </div>
            <div class="col-12">
            <ng-container *ngIf="typeOfView === 'SampleView'">
               <div class="mb-2">
              <p-dropdown [(ngModel)]="selectedDropdownValue" [options]="searchDropdownOptions"></p-dropdown>
            </div>
            </ng-container>
               <input style="height: 36px;" [disabled]="disabledInputField()" pInputText type="text" #idInput id="searchField" placeholder="Enter ID to search" (keyup.enter)="search(idInput.value)" />
                <button style="height: 36px;" pButton label="Go" [disabled]="disableSearchIf(idInput.value)" (click)="search(idInput.value)"></button>
          </div>
        </div>
      </div>
  </div>
</div>
<div class="col-12 p-0" class="text-center flex" >
  <div class="col-6 p-0" *ngIf="isPlate">
    <h4><strong>Plate</strong></h4>
    <h5>Plate Metadata</h5>
    <div class="col">
      <div class="row">
        <div>
          <table aria-describedby="Plate Information Table" class="plateTable">
            <tbody class="searchPlateBody">
              <tr>
                <th scope="row">Plate ID</th>
                <td>{{selectedPlate.plateID}}</td>
              </tr>
              <tr>
                <th scope="row">Sender</th>
                <td>{{selectedPlate.sender}}</td>
              </tr>
              <tr>
                <th scope="row">Type</th>
                <td>{{selectedPlate.type}}</td>
              </tr>
              <tr>
                <th scope="row">Status</th>
                <td>{{selectedPlate.status}}</td>
              </tr>
              <tr>
                <th scope="row">Creation Date</th>
                <td>{{selectedPlate.creationDate | date:'dd.MM.yyyy'}}</td>
              </tr>
              <tr>
                <th scope="row">Sample Type</th>
                <td>{{selectedPlate.sampleType}}</td>
              </tr>
              <tr>
                <th scope="row">Process Flow Name</th>
                <td>{{selectedPlate.processFlowName}}</td>
              </tr>
              <tr>
                <th scope="row">Priority</th>
                <td>{{selectedPlate.priority}}</td>
              </tr>
              <tr *ngIf="selectedPlate.runId">
                <th scope="row">Run ID</th>
                <td>{{selectedPlate.runId}}</td>
              </tr>
              <tr>
                <th scope="row">Source Plates</th>
                <td>
                  {{sourcePlates.join(', ')}}
              </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <br>
  </div>
  <div *ngIf="isPlate && canBeRenderedForGivenClaim">
    <div class=" row secondDiv p-0">
      <div class=" col col-5" style="margin-left: 2rem;">
        <div class="ui-inputgroup flex text-left input1" style="width: 230% !important;">
          <buttom pButton class="theme-button noHover redoTypeButton" type="button" label="External Redo"></buttom>
          <input pInputText class="paddingMargin" style="width: fit-content;" name="profile" type="file"
          accept=".xlsx" (change)="onFileSelect($event)" id="fileChooser" placeholder="Upload File"
          #externalRedoFile/>
        </div>

        <div class="ui-inputgroup input1" style="width: 173% !important;">
          <button pButton
            class="theme-button redoPlateButton" [disabled]="!isFileSelected" (click)="uploadExternalRedoFile()" type="button" label="Upload"></button>
        </div>

        <div class="ui-inputgroup flex text-left input1" style="width: 165%;">
          <button pButton class="theme-button noHover redoTypeButton" type="button" label="Redo Type"></button>
          <p-dropdown #popUpRedoSelector [options]="redoList" [(ngModel)]="selectedRedoReason"
          optionLabel="label" optionValue="value" placeholder="Select Redo Type" [disabled]="redoList.length === 0"></p-dropdown>
        </div>

        <div class="ui-inputgroup input1">
          <button pButton
            class="theme-button  redoPlateButton" style="margin-left: 10rem;" type="button" label="Redo Plate" (click)="redoPlate()" [disabled]="redoList.length === 0"></button>
        </div>
        <div class="ui-inputgroup flex text-left input1" style="width: 178% !important;">
          <button pButton class="theme-button noHover statusButton" type="button" label="Status"></button>
          <p-dropdown placeholder="Select Status Type" [options]="statusList" name="statusList" optionValue="value" optionLabel="label" [(ngModel)]="selectedStatus" [disabled]="disableStatusDropDown()">
          </p-dropdown>
        </div>

        <div class="ui-inputgroup input1" style="width: 72%;">
          <button pButton class="theme-button statusTypeButton" type="button" label="Change Status to"
            (click)="openPlateIDSelectionPopUp()" [disabled]="!selectedStatus"></button>
        </div>

        <div class="ui-inputgroup flex text-left input1" style="width: 188% !important;">
          <button pButton class="theme-button noHover sampleTypeDropdown" type="button" label="Sample-Type"></button>
          <p-dropdown placeholder="Select Sample-Type" filter="true" [options]="sampleTypeList"
            name="sampleList" [(ngModel)]="selectedSampleType">
          </p-dropdown>
        </div>

        <div class="ui-inputgroup input1">
          <button pButton class="theme-button sampleTypeButton" type="button" label="Change Type"
            (click)="updatePlateProcessflowname()" [disabled]="!selectedSampleType"></button>
        </div>

      </div>

        <p-dialog header="{{selectedPlate.plateID + ' Comments'}}" [(visible)]="showCommentDialog" [modal]="true"
          position="top" [contentStyle]="{'max-height':'70vh'}">
          <div class="col-12 p-0 rounded border border-secondary commentBubble">
            <div style="text-align:left" class="col-11 pb-0">
              <label><strong> Plate : </strong>{{selectedPlateID}}</label>
            </div>
            <div class="col-1 pb-0" style="margin-top: -3%; margin-left: 94%;">
              <button *ngIf="beadChipCommentsDisplayMap.get('showPlateCommentList')" type="button"
                class="float-right btn btn-outline-secondary border-0 p-0"
                (click)="setBeadchipDisplay('showPlateCommentList',false)"><em
                  class="fa fa-window-minimize"></em></button>
              <button *ngIf="!beadChipCommentsDisplayMap.get('showPlateCommentList')" type="button"
                class="float-right btn btn-outline-secondary border-0 p-0"
                (click)="setBeadchipDisplay('showPlateCommentList',true)"><em
                  class=" fa fa-window-maximize"></em></button>
            </div>
            <div *ngIf="beadChipCommentsDisplayMap.get('showPlateCommentList')">
              <div *ngFor="let comment of plateCommentsList">
                <div class="col-12 p-0 commentBubbleSection">
                  <div style="text-align:left" class="col-12 commentPUIDDate">
                    <label>{{comment.puid}} | {{convertUtcToLocal(comment.timeStamp) | date: 'dd.MM.yy HH:mm'}} |
                      {{comment.status}}</label>
                  </div>
                  <div style="text-align:left" class="col-12 commentPUIDDate font-weight-bold">
                    <p>{{comment.comment}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngFor="let beadchip of beadChipCommentsMap | keyvalue">
            <div class="col-12 p-0 rounded border border-secondary commentBubble beadChipHeader">
              <div style="text-align:left" class="col-11 pb-0">
                <label><strong>BeadChip : </strong> {{beadchip.key}}</label>
              </div>
              <div class="col-1 pb-0">
                <button *ngIf="beadChipCommentsDisplayMap.get(beadchip.key)" type="button"
                  class="float-right btn btn-outline-secondary border-0 p-0"
                  (click)="setBeadchipDisplay(beadchip.key,false)"><em class="fa fa-window-minimize"></em></button>
                <button *ngIf="!beadChipCommentsDisplayMap.get(beadchip.key)" type="button"
                  class="float-right btn btn-outline-secondary border-0 p-0"
                  (click)="setBeadchipDisplay(beadchip.key,true)"><em class="fa fa-window-maximize"></em></button>
              </div>
              <div *ngIf="beadChipCommentsDisplayMap.get(beadchip.key)">
                <div *ngFor="let comment of plateCommentsList">
                  <div class="col-12 p-0 commentBubbleSection">
                    <div style="text-align:left" class="col-12 commentPUIDDate">
                      <label>{{comment.puid}} | {{convertUtcToLocal(comment.timeStamp) | date: 'dd.MM.yy HH:mm'}} |
                        {{comment.beadchipstatus}}</label>
                    </div>
                    <div style="text-align:left" class="col-12 commentPUIDDate font-weight-bold">
                      <p>{{comment.comment}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12" id="commentTextAreDiv">
            <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..."
              [(ngModel)]="newComment"></textarea>
          </div>
          <div style="text-align:left" class="col-12 addCommentButton">
            <button style = "height: 2.5rem;" pButton label="Add Comment" [disabled]="!(newComment != null && newComment.trim() != '')"
              (click)="saveComment()"></button>
          </div>
        </p-dialog>
      </div>
    </div>
  </div>

  <div class="text-center flex">
  <div class="col-12 p-0" *ngIf="isPlate">
    <div>
      <button class="paddingMargin floatLeft" style="margin-left: 2rem; width: 12%;" pButton label="Batch Comments" (click)="showComments()"></button>
      <button class="paddingMargin" style="margin-right: -13rem; width: 11%;" pButton label="Download Excel" (click)="downloadExcelFile()"></button>
    </div>
    <h4 style="margin-right: 27rem;" *ngIf="processDataList.length>0">Plate Process data</h4>
    <div *ngIf="processDataList.length>0" class="row">
      <p-table style="width: 80rem;" [value]="processDataList" selectionMode="single">
        <ng-template pTemplate="header">
          <tr>
            <th class="batchId" id="batchId">Batch ID</th>
            <th class="stepAction" scope="col">
              <div>Step</div>
              <div>Action</div>
            </th>
            <th class="puid" id="puid">PUID</th>
            <th class="timeStamp" id="timeStamp">Time</th>
            <th class="equipment" id="equipment">Equipment</th>
            <th class="reagents" id="reagents">Reagents</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-processDataList>
          <tr [pSelectableRow]="processDataList">
            <td class="leftTable wordBreak">
              {{processDataList?.plateId}}
            </td>
            <td>
              <div class="wordBreak" *ngFor="let step of getSteps(processDataList.stepAction)">
                {{step}}
              </div>
            </td>
            <td>
              {{processDataList?.puid}}
            </td>
            <td class="wordBreak">
              {{processDataList?.stepTime}}
            </td>
            <td class="wordBreak">
              {{processDataList?.equipment}}
            </td>
            <td>
              <div class="wordBreak" *ngFor="let chem of processDataList.reagents">
                {{chem.chemical}}: {{chem.lots}}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<div class="col-12 p-0" class="text-center">
  <div class="col-6" *ngIf="isBeadchip">
  <div class="col">
    <div class="row">
      <h4 class="">Beadchip</h4>
      <div>
        <table aria-describedby="BeadChip Information Table" class="beadChipTable">
          <tbody class="beadChipTableBody">
            <tr>
              <th scope="row">Beadchip</th>
              <td>{{searchedBeadchipID}}</td>
              <th scope="row">Sender</th>
              <td>{{selectedPlate.sender}}</td>
            </tr>
            <tr>
              <th scope="row">Source Plate</th>
              <td>{{selectedPlate.plateID}}</td>
              <th scope="row">Workflow</th>
              <td>{{selectedPlate.workFlow}}</td>
            </tr>
            <tr>
              <th scope="row">Current Status</th>
              <td colspan="3">{{beadchipStatus}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br>
    <div class="row">
      <button pButton class="showButton" type="button" label="Show Beadchip" (click)="showBeadchip()"></button>
    </div>
    <br>

    <div class="row secondDiv p-0">
      <p-fieldset legend="Update Batch" class="col-12">
        <div class="col col-7 leftDiv">
          <div class="ui-inputgroup input">
            <button pButton class="theme-button noHover actionButtons" type="button" label="Reset Status"></button>
            <p-dropdown [options]="plateStatus" class="dropdown" (onChange)="updatedStatusFun($event.value)" placeholder="Reset Batch to Status">
            </p-dropdown>
          </div>

          <p-dialog header="{{selectedBeadChipID + ' Comments'}}" [(visible)]="showCommentDialog" [modal]="true" position="top" [contentStyle]="{'max-height':'70vh'}">
            <div class="col-12 p-0 rounded border border-secondary commentBubble">
              <div style="text-align:left" class="col-11 pb-0">
                <label><strong> Plate : </strong>{{selectedPlateID}}</label>
              </div>
              <div class="col-1 pb-0">
                <button *ngIf="beadChipCommentsDisplayMap.get('showPlateCommentList')" type="button"
                  class="float-right btn btn-outline-secondary border-0 p-0"
                  (click)="setBeadchipDisplay('showPlateCommentList',false)"><em class="fa fa-window-minimize"></em></button>
                <button *ngIf="!beadChipCommentsDisplayMap.get('showPlateCommentList')" type="button"
                  class="float-right btn btn-outline-secondary border-0 p-0"
                  (click)="setBeadchipDisplay('showPlateCommentList',true)"><em class=" fa fa-window-maximize"></em></button>
              </div>
              <div *ngIf="beadChipCommentsDisplayMap.get('showPlateCommentList')">
                <div *ngFor="let comment of plateCommentsList">
                  <div class="col-12 p-0 commentBubbleSection">
                    <div style="text-align:left" class="col-12 commentPUIDDate">
                      <label>{{comment.puid}} | {{convertUtcToLocal(comment.timeStamp) | date: 'dd.MM.yy HH:mm'}} | {{comment.status}}</label>
                    </div>
                    <div style="text-align:left" class="col-12 commentPUIDDate font-weight-bold">
                      <p>{{comment.comment}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <div *ngFor="let beadchip of beadChipCommentsMap | keyvalue">
              <div class="col-12 p-0 rounded border border-secondary commentBubble beadChipHeader">
                <div style="text-align:left" class="col-11 pb-0">
                  <label><strong>BeadChip : </strong> {{beadchip.key}}</label>
                </div>
                <div class="col-1 pb-0">
                  <button *ngIf="beadChipCommentsDisplayMap.get(beadchip.key)" type="button"
                    class="float-right btn btn-outline-secondary border-0 p-0" (click)="setBeadchipDisplay(beadchip.key,false)"><em
                      class="fa fa-window-minimize"></em></button>
                  <button *ngIf="!beadChipCommentsDisplayMap.get(beadchip.key)" type="button"
                    class="float-right btn btn-outline-secondary border-0 p-0" (click)="setBeadchipDisplay(beadchip.key,true)"><em
                      class="fa fa-window-maximize"></em></button>
                </div>
                <div *ngIf="beadChipCommentsDisplayMap.get(beadchip.key)">
                  <div *ngFor="let comment of beadchip.value">
                    <div class="col-12 p-0 commentBubbleSection">
                      <div style="text-align:left" class="col-12 commentPUIDDate">
                        <label>{{comment.puid}} | {{convertUtcToLocal(comment.timeStamp) | date: 'dd.MM.yy HH:mm'}} | {{comment.beadchipstatus}}</label>
                      </div>
                      <div style="text-align:left" class="col-12 commentPUIDDate font-weight-bold">
                        <p>{{comment.comment}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <div class="col-12" id="commentTextAreDiv">
              <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..."
                [(ngModel)]="newComment"></textarea>
            </div>
            <div style="text-align:left" class="col-12 addCommentButton">
              <button pButton label="Add Comment" [disabled]="!(newComment != null && newComment.trim() != '')"
                (click)="saveComment()"></button>
            </div>

          </p-dialog>


          <div class="ui-inputgroup input">
            <button pButton class="theme-button noHover actionButtons" type="button" label="Rush"></button>
            <p-checkbox binary="true" class="checkBoxx"> </p-checkbox>
          </div>

          <div class="ui-inputgroup input">
            <button pButton class="theme-button noHover actionButtons" type="button" label="Super Rush"></button>
            <p-checkbox binary="true" class="checkBoxx"> </p-checkbox>
          </div>

          <div class="ui-inputgroup input">
            <button pButton style="background-color: #41827E" class="theme-button actionButtons" type="button" (click)="showComments()" label="Update Beadchip Status"></button>
          </div>
        </div>
        <div class="col col-5 rightDiv">
          <div class="ui-inputgroup input">
            <div class="updatePlate">
              <button pButton class="redoButton" type="button" label="Redo">
              </button>
            </div>
          </div>
          <div class="ui-inputgroup input">
            <div class="updatePlate">
              <button pButton class="removeUnnecessaryRedoButton" type="button" label="Remove Unnexessary Redo"></button>
            </div>
          </div>
          <div class="ui-inputgroup input">
            <div class="updatePlate">
              <button pButton class="changeFalseRedoButton" type="button" label="Change False Redo"></button>
            </div>
          </div>
          <div class="ui-inputgroup input">
            <div class="updatePlate">
              <button pButton class="removeBatchButton" type="button" label="Remove Batch"></button>
            </div>
          </div>
          <div class="ui-inputgroup input">
            <div>
              <button pButton class="completeBatchButton" type="button" label="Compelete Batch"></button>
            </div>
          </div>
        </div>
      </p-fieldset>
    </div>
  </div>
  </div>
</div>


<div class="col-12 p-0" class="sample-text-center">
  <div class="col-8 col" *ngIf="isSample">
    <h4>Sample</h4>
    <h5 class="">Sample Metadata</h5>
    <div class="tableCenter">
      <table aria-describedby="Plate Information Table" class="sampleMetaData">
        <thead>
          <tr>
            <th style="display: none;"></th>
          </tr>
        </thead>
        <tbody class="plateTableBody">
          <tr>
            <td>
              barCode
            </td>
            <td>
              {{sampleData?.barCode}}
            </td>
          </tr>
          <tr *ngFor="let item of sampleData | keyvalue">
            <td class="wordBreak" *ngIf="checkIfUsableValueOrNot(item)">
              {{renameKeys(item.key)}}
            </td>
            <td class="wordBreak" *ngIf="checkIfUsableValueOrNot(item)">
              {{formatData(item.key, item.value)}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <br>
    <div>
      <button class="paddingMargin floatLeft" pButton label="Batch Comments" (click)="openBatchComments()"></button>
      <button class="paddingMargin floatLeft" pButton label="Sample Comments" (click)="openSampleComments()"></button>
      <button class="paddingMargin floatRight" pButton label="Download Excel" (click)="downloadExcelFile()"></button>
    </div>
    <br>
  </div>
  <br>
  <div class="col-12 col setPosition" *ngIf="isSample">
    <h4 *ngIf="processDataList.length>0">Sample Process data</h4>
    <div *ngIf="processDataList.length>0" class="row" style="display: block;">
      <p-table id="excel-table" [value]="processDataList" selectionMode="single">
      <ng-template pTemplate="header">
        <tr>
          <th class="batchId" id="batchId">Batch ID</th>
          <th class="puid" id="puid">Pos</th>
          <th class="stepAction" scope="col">
            <div>Step</div>
            <div>Action</div>
          </th>
          <th class="puid" id="puid">PUID</th>
          <th class="timeStamp" id="timeStamp">Time</th>
          <th class="equipment" id="equipment">Equipment</th>
          <th class="reagents" id="reagents">Reagents</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-plate>
        <tr [pSelectableRow]="plate">
          <td class="leftTable wordBreak">
            {{plate?.plateId}}
          </td>
          <td class="wordBreak">
            {{plate?.position}}
          </td>
          <td>
            <div  class="wordBreak" *ngFor="let step of getSteps(plate.stepAction)">
              {{step}}
            </div>
          </td>
          <td class="wordBreak">
            {{plate?.puid}}
          </td>
          <td  class="wordBreak">
            {{plate?.stepTime}}
          </td>
          <td class="wordBreak">
            {{plate?.equipment}}
          </td>
          <td>
            <div class="wordBreak" *ngFor="let chem of plate.reagents">
              {{chem.chemical}}: {{chem.lots}}
            </div>
          </td>
        </tr>
      </ng-template>
      </p-table>
    </div>
  </div>
</div>

<div class="col-12 p-0" class="text-center">
  <div class="col-6 p-0" *ngIf="isBatch">
<div class="col">
  <div class="row">
    <h4 class="">Batch : {{selectedBatchBatchID}}</h4>
    <div>
      <table aria-describedby="Plate Information Table" class="plateTable">
        <tbody class="plateTableBody">
          <tr>
            <th scope="row">Batch ID</th>
            <td>{{selectedBatchBatchID}}</td>
            <th scope="row">Sender</th>
            <td>{{selectedBatchSender}}</td>
          </tr>
          <tr>
            <th scope="row">Current Status</th>
            <td colspan="3">{{selectedBatchStatus}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
    <br>

    <div class=" row secondDiv p-0" >
      <p-fieldset legend="Update Batch" class ="col-12">
        <div class=" col col-7">
            <div class="ui-inputgroup input1" >
              <button pButton class="theme-button noHover actionButtons" type="button" label="Reset Status"></button>
              <p-dropdown [options]="plateStatus" class="dropdown" (onChange)="updatedStatusFun($event.value)" placeholder="Reset Batch to Status">
              </p-dropdown>
            </div>

            <p-dialog header="{{selectedBatchBatchID + ' Comments'}}" [(visible)]="showCommentDialog" [modal]="true" position="top" [contentStyle]="{'max-height':'70vh'}">
              <div class="col-12 p-0 rounded border border-secondary commentBubble">
                <div style="text-align:left" class="col-11 pb-0">
                  <label><strong> Batch : </strong>{{selectedBatchBatchID}}</label>
                </div>
                <div class="col-1 pb-0">
                  <button *ngIf="beadChipCommentsDisplayMap.get('showPlateCommentList')" type="button"
                    class="float-right btn btn-outline-secondary border-0 p-0"
                    (click)="setBeadchipDisplay('showPlateCommentList',false)"><em class="fa fa-window-minimize"></em></button>
                  <button *ngIf="!beadChipCommentsDisplayMap.get('showPlateCommentList')" type="button"
                    class="float-right btn btn-outline-secondary border-0 p-0"
                    (click)="setBeadchipDisplay('showPlateCommentList',true)"><em class=" fa fa-window-maximize"></em></button>
                </div>
                <div *ngIf="beadChipCommentsDisplayMap.get('showPlateCommentList')">
                  <div *ngFor="let comment of batchCommentsList">
                    <div class="col-12 p-0 commentBubbleSection">
                      <div style="text-align:left" class="col-12 commentPUIDDate">
                        <label>{{comment.puid}} | {{convertUtcToLocal(comment.commentDate) | date: 'dd.MM.yy HH:mm'}} </label>
                      </div>
                      <div style="text-align:left" class="col-12 commentPUIDDate font-weight-bold">
                        <p>{{comment.userComment}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br>
              <br>
              <div class="col-12" id="commentTextAreDiv">
                <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..."
                  [(ngModel)]="newComment"></textarea>
              </div>
              <div style="text-align:left" class="col-12 addCommentButton">
                <button pButton label="Add Comment" [disabled]="!(newComment != null && newComment.trim() != '')"
                  (click)="saveBatchComment(newComment)"></button>
              </div>

            </p-dialog>

            <div class="ui-inputgroup input1" >
              <button pButton class="theme-button noHover actionButtons" type="button" label="Rush"></button>
              <p-checkbox binary="true" class="checkBoxx"> </p-checkbox>
            </div>

            <div class="ui-inputgroup input1" >
              <button pButton class="theme-button noHover actionButtons" type="button" label="Super Rush"></button>
              <p-checkbox binary="true" class="checkBoxx"> </p-checkbox>
            </div>

            <div class="ui-inputgroup input1" >
              <button pButton style="background-color: #41827E" class="theme-button actionButtons" type="button" (click)="showComments()" label="Update Batch Status"></button>
            </div>
        </div>
        <div class=" col col-5" style="padding-left: 2.5em;">
            <div class="ui-inputgroup input1" >
              <div class="updatePlate">
                <button pButton class="redoButton" type="button" label="Redo">
                </button>
              </div>
            </div>
            <div class="ui-inputgroup input1" >
              <div class="updatePlate">
                <button pButton class="removeUnnecessaryRedoButton" type="button" label="Remove Unnexessary Redo"></button>
              </div>
            </div>
            <div class="ui-inputgroup input1" >
              <div class="updatePlate">
                <button pButton class="changeFalseRedoButton" type="button" label="Change False Redo"></button>
              </div>
            </div>
            <div class="ui-inputgroup input1" >
              <div class="updatePlate">
                <button pButton class="removeBatchButton" type="button" label="Remove Batch"></button>
              </div>
            </div>
            <div class="ui-inputgroup input1" >
              <div>
                <button pButton class="completeBatchButton" type="button" label="Compelete Batch"></button>
              </div>
            </div>
        </div>
      </p-fieldset>
    </div>
  </div>
  </div>
</div>


<p-dialog header="Please select a sample" showEffect="fade" position="top"
    [(visible)]="duplicateSamplesPresent" [modal]="true" [style.width]="'700px'"
    [contentStyle]="{'max-height':'70vh'}" (onHide)="resetValues()">
    <div class="content-in-multi-update-popup">
      <table id="scanTable" aria-describedby="View samples">
        <tbody>
          <tr>
            <th class="popupHeaderBorder">Sample ID</th>
            <th class="popupHeaderBorder">SampleType</th>
            <th class="popupHeaderBorder">Activated</th>
            <th class="popupHeaderBorder">Gender</th>
            <th class="popupHeaderBorder">Announced</th>
            <th class="popupHeaderBorder"></th>
          </tr>
          <tr *ngFor="let sample of allSelectedSamples; let i=index">
            <td>{{sample.barCode}}</td>
            <td>{{sample.sampleType}}</td>
            <td>{{sample.activated? "Yes" : "No"}}</td>
            <td>{{sample.gender}}</td>
            <td>{{sample.announcedDate | date: 'dd.MM.yy'}}</td>
            <td>
              <button class="removeMargin buttonsRound endButton ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" (click)="selectedSampleFromScan(sample)">Select Sample</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</p-dialog>

<p-dialog header="Sample comment(s)" [(visible)]="sampleCommentsBoolean" [modal]="true" position="top" [contentStyle]="{'max-height':'70vh'}" (onHide)="resetValues()">
  <div class="col-12 p-0 rounded border border-secondary commentBubble">
    <div class="col-11 pb-0">
      <label><strong> Sample : </strong>{{sampleData?.barCode}}</label>
    </div>
    <div class="col-1 pb-0">
      <button *ngIf="commentsDisplayMap.get('showCommentList')" type="button"
        class="float-right btn btn-outline-secondary border-0 p-0"
        (click)="setCommentsDisplay('showCommentList',false)"><em class="fa fa-window-minimize"></em></button>
      <button *ngIf="!commentsDisplayMap.get('showCommentList')" type="button"
        class="float-right btn btn-outline-secondary border-0 p-0"
        (click)="setCommentsDisplay('showCommentList',true)"><em class=" fa fa-window-maximize"></em></button>
    </div>
    <div *ngIf="commentsDisplayMap.get('showCommentList')">
      <div *ngFor="let comment of comments">
        <div class="col-12 p-0 commentBubbleSection">
          <div class="col-12 commentPUIDDate">
            <label>{{comment.puid}} | {{comment.timeStamp | date: 'dd.MM.yy HH:mm'}} | {{comment.status}}</label>
          </div>
          <div class="col-12 commentPUIDDate font-weight-bold">
            <p>{{comment.comment}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>
  <div class="col-12" id="commentTextAreDiv">
    <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..."
      [(ngModel)]="newSampleComment"></textarea>
  </div>
  <div class="col-12 addCommentButton">
    <button pButton label="Add Comment" [disabled]="!(newSampleComment != null && newSampleComment.trim() != '')"
      (click)="saveSampleComment()"></button>
  </div>
</p-dialog>


<p-dialog header="Plate comment(s)" [(visible)]="batchCommentsBoolean" [modal]="true" position="top" [contentStyle]="{'max-height':'70vh'}" (onHide)="resetValues()">
  <div class="col-12 p-0 rounded border border-secondary commentBubble">
    <div class="col-11 pb-0">
      <label><strong> Plate : </strong>{{sampleData?.lastUpdatedPlateID}}</label>
    </div>
    <div class="col-1 pb-0">
      <button *ngIf="commentsDisplayMap.get('showCommentList')" type="button"
        class="float-right btn btn-outline-secondary border-0 p-0"
        (click)="setCommentsDisplay('showCommentList',false)"><em class="fa fa-window-minimize"></em></button>
      <button *ngIf="!commentsDisplayMap.get('showCommentList')" type="button"
        class="float-right btn btn-outline-secondary border-0 p-0"
        (click)="setCommentsDisplay('showCommentList',true)"><em class=" fa fa-window-maximize"></em></button>
    </div>
    <div *ngIf="commentsDisplayMap.get('showCommentList')">
      <div *ngFor="let comment of plateComments">
        <div class="col-12 p-0 commentBubbleSection">
          <div class="col-12 commentPUIDDate">
            <label>{{comment.puid}} | {{comment.timeStamp | date: 'dd.MM.yy HH:mm'}} | {{comment.status}}</label>
          </div>
          <div class="col-12 commentPUIDDate font-weight-bold">
            <p>{{comment.comment}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>
  <div class="col-12" id="commentTextAreDiv">
    <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..."
      [(ngModel)]="newComment"></textarea>
  </div>
  <div class="col-12 addCommentButton">
    <button pButton label="Add Comment" [disabled]="!(newComment!= null && newComment.trim() != '')"
      (click)="savePlateComment()"></button>
  </div>
</p-dialog>


<p-dialog header="Plate ID Selection" [(visible)]="plateIDSelectionDialog" [modal]="true" position="centre" (onHide)="resetValues()">
  <div class="ui-g-12">
    <table class="table">
      <thead>
        <tr>
          <th class="tableBorder"></th>
          <th class="tableBorder"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="tableBorder">
            <h6>You are about to change status of <strong>{{selectedPlate?.lastUpdatedPlateID}}</strong> to <strong>{{selectedStatus}}</strong>.<br/> Please select an ID type to continue...</h6>
          </td>
        </tr>
        <tr>
          <td class="ui-g-6 borderLessRow">
            <span><strong>Select ID Type</strong></span>
          </td>
          <td class="ui-g-6 borderLessRow">
            <span><strong>Preview</strong></span>
          </td>
        </tr>
        <tr>
          <td class="ui-g-6 borderLessRow">
            <p-dropdown [options]="plateIDList"[(ngModel)]="selectedPlateIDType"></p-dropdown>
          </td>
          <td class="ui-g-6 borderLessRow" *ngIf="selectedPlateIDType != null">
            <span>Current: <strong> {{selectedPlate?.lastUpdatedPlateID}}</strong></span>
            <br/>
            <span>Updated: <strong>{{selectedPlate[selectedPlateIDType.key]}}</strong></span>
          </td>
        </tr>
        <tr>
          <td class="ui-g-6 borderLessRow"></td>
          <td class="ui-g-6 borderLessRow">
            <button pButton class="theme-button popUpStatusChangeButton" label="Status change" (click)="updatePlateSelectedStatus()"></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</p-dialog>


<p-dialog header="Redo Selection For Merged Plates" [(visible)]="popUpWithQCCheckForMergePlate" showEffect="fade" position="centre" [modal]="true" (onHide)="resetValues()">
  <div class="content-in-multi-update-popup row">
    <div class="ui-g-12">
      <table aria-describedby="View Plates" class="table">
        <tr>
          <th style="border:none"></th>
        </tr>
        <tr>
          <td class="qc-check-table-td p-3 borderLessRow">
            <div>
              <span style="font-weight: 700;">Merged Plate - {{selectedPlate?.lastUpdatedPlateID}}</span>
            </div>
          </td>
          <td class="qc-check-table-td p-3 borderLessRow"></td>
        </tr>
        <tr *ngFor="let sourcePlate of this.selectedPlate?.sourcePlates; let i = index;">
          <td class="qc-check-table-td p-3 borderLessRow">
            <div class="p-1">PlateID - {{sourcePlate.plateID}}</div><br/>
            <span class="p-1">Sample Type - {{sourcePlate.sampleType}}</span>
          </td>
          <td class="qc-check-table-td p-3 borderLessRow">
            <p-dropdown placeholder="Select Redo" [options]="mergePlateRedoList[i]" [(ngModel)]="mergePlateRedoSelection[i]"></p-dropdown>
          </td>
        </tr>
      </table>
    </div>
    <div class="ui-g-12">
      <button pButton label="Set Redo"
        class="buttonsRound multi_UpdateButton qcFailMB"
        (click)="sendSourcePlatesForRedo()">
      </button>
    </div>
  </div>
</p-dialog>
